import Flightpath from './flightpath';

export default Flightpath;
